module.exports = __webpack_public_path__ + "static/media/navbar.ec7897ad.svg";